import React from 'react'

function UserAlert({text}) {
  return (
    <div className='user-alert' >
      {text}
    </div>
  )
}

export default UserAlert
